import styled, { css } from 'styled-components';
import { svgToCssUrl } from 'src/utils/svgToCssUrl';
import { SvgHelperWrapper } from 'src/components';
import LevelUpBackground from '../assets/level-up-background.svg';

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    color: ${theme.co.secondary20};
    background-color: ${theme.co.primary98};
    background-position: center;
    background-size: cover;
    background-image: ${svgToCssUrl(<SvgHelperWrapper Svg={LevelUpBackground} />)};
  `,
);

export const Header = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xl};
    margin: ${theme.sz.s1};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};
    color: ${theme.co.secondary50};
  `,
);

export const LevelWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    width: ${theme.sz.xs};
    height: ${theme.sz.s48};
    display: flex;
    justify-content: center;
    align-items: end;
    padding-bottom: ${theme.sz.s6};
  `,
);

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: -${theme.sz.s8};
    z-index: 0;
  `,
);

export const LevelNumber = styled.div(
  () => css`
    z-index: 1;
  `,
);

export const Language = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xxl};
    color: ${theme.co.secondary20};
    margin-top: 0;
    margin-bottom: ${theme.sz.s1};
  `,
);

export const Level = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    margin-bottom: ${theme.sz.s10};
  `,
);
